import { useEffect, useRef } from 'react';

import { useFleet } from './useFleet';

export const useDefaultMapCenter = (): [longitude: number, latitude: number] => {
  const fleet = useFleet();

  const defaultCenterCoords = useRef([
    fleet.config.portal_config?.map?.default_longitude ?? 0,
    fleet.config.portal_config?.map?.default_latitude ?? 0,
  ]);

  useEffect(() => {
    defaultCenterCoords.current = [
      fleet.config.portal_config?.map?.default_longitude ?? 0,
      fleet.config.portal_config?.map?.default_latitude ?? 0,
    ];
  }, [fleet.config.portal_config?.map?.default_longitude, fleet.config.portal_config?.map?.default_latitude]);

  return defaultCenterCoords.current;
};
